/**
 * 자동 생산 시스템
 * CPS 기반 코인 자동 생성 + 메타버스 자동 탭
 */

import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';
import { getCurrentCPS, getCurrentClickPower } from '../state.js';

export const autoProductionSystem: TickSystem<GameState, GameAction> = {
  name: 'autoProduction',

  update(state, deltaTime) {
    if (!state.isRunning) return state;

    const deltaSeconds = deltaTime / 1000;
    let newState = { ...state };

    // CPS 기반 자동 생산
    const cps = getCurrentCPS(state);
    const earnings = cps * deltaSeconds;

    if (earnings > 0) {
      newState.coins += earnings;
      newState.totalEarnedThisRun += earnings;
      newState.statistics = {
        ...newState.statistics,
        totalEarned: newState.statistics.totalEarned + earnings
      };
    }

    // 메타버스 자동 탭 (1초마다)
    if (state.prestige2.purchasedUpgrades.includes('meta_auto_tap')) {
      const interval = 1000; // 1초
      const taps = Math.floor(deltaTime / interval);

      if (taps > 0) {
        const clickPower = getCurrentClickPower(state);
        const tapEarnings = clickPower * taps;

        newState.coins += tapEarnings;
        newState.totalEarnedThisRun += tapEarnings;
        newState.statistics = {
          ...newState.statistics,
          totalEarned: newState.statistics.totalEarned + tapEarnings,
          totalClicks: newState.statistics.totalClicks + taps
        };
      }
    }

    return earnings > 0 ? newState : state;
  }
};
